import { EditTypes } from '@hyundai/shared-lib/edit';
import type { DialogTag } from '@pixelgenau/ngx-dialog';
import { EditAboutUsTeaserTag } from '../components/dialogs/edit-about-us-teaser/edit-about-us-teaser.dialog';
import { EditEmployeesDialogTag } from '../components/dialogs/edit-employees/edit-employees.dialog';
import { EditImageTextDialogTag } from '../components/dialogs/edit-image-text/edit-image-text.dialog';
import { EditImageDialogTag } from '../components/dialogs/edit-image/edit-image.dialog';
import { EditRTEDialogTag } from '../components/dialogs/edit-rte/edit.rte.dialog';
import { EditSelectContentListDialogTag } from '../components/dialogs/edit-select-content-list/edit.select-content-list.dialog';
import { EditSelectListDialogTag } from '../components/dialogs/edit-select-list/edit.select-list.dialog';
import { EditSelectTextListDialogTag } from '../components/dialogs/edit-select-text-list/edit.select-text-list.dialog';
import { EditTextAreaDialogTag } from '../components/dialogs/edit-text-area/edit.text-area.dialog';
import { EditTextListDialogTag } from '../components/dialogs/edit-text-list/edit.text-list.dialog';
import { EditTextDialogTag } from '../components/dialogs/edit-text/edit.text.dialog';
import { EditThemeDialogTag } from '../components/dialogs/edit-theme/edit.theme.dialog';

export type EditableDialogs = Record<EditTypes, DialogTag>;

export const EDITABLE_DIALOGS: EditableDialogs = {
    [EditTypes.TEXT]: EditTextDialogTag,
    [EditTypes.TEXTAREA]: EditTextAreaDialogTag,
    [EditTypes.IMAGE]: EditImageDialogTag,
    [EditTypes.RICH_TEXT]: EditRTEDialogTag,
    [EditTypes.ABOUT_US_TEASER]: EditAboutUsTeaserTag,
    [EditTypes.EMPLOYEES]: EditEmployeesDialogTag,
    [EditTypes.TEXT_LIST]: EditTextListDialogTag,
    [EditTypes.SELECT_TEXT_LIST]: EditSelectTextListDialogTag,
    [EditTypes.SELECT_CONTENT_LIST]: EditSelectContentListDialogTag,
    [EditTypes.SELECT_LIST]: EditSelectListDialogTag,
    [EditTypes.THEME]: EditThemeDialogTag,
    [EditTypes.SETTING]: EditTextDialogTag,
    [EditTypes.IMAGE_TEXT]: EditImageTextDialogTag,
};
